<template>
  <q-btn-dropdown
    v-if="sizesToDisplay.length > 0"
    ref="dropdown"
    size="sm"
    no-caps
    dense
    flat
    icon="format_size"
    label="Text Size"
  >
    <q-list dense class="html">
      <q-item-wrapper
        v-for="opt in sizesToDisplay"
        :key="opt.size"
        tag="label"
        clickable
        @click="onSizeClick(opt)"
      >
        <font :size="opt.size">
          {{ opt.label }}
        </font>
      </q-item-wrapper>
    </q-list>
  </q-btn-dropdown>
</template>

<script>
export default {
  props: {
    restrictedToSizes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['run'],
  data () {
    return {
      sizeOptions: [
        { label: 'Very Small', size: 1 },
        { label: 'Smaller', size: 2 },
        { label: 'Normal', size: 3 },
        { label: 'Larger', size: 4 },
        { label: 'Big', size: 5 },
        { label: 'Very Big', size: 6 },
        { label: 'Maximum', size: 7 }
      ]
    }
  },
  computed: {
    sizesToDisplay () {
      if (this.restrictedToSizes.length < 1) {
        return this.sizeOptions
      }
      return this.sizeOptions.filter(item => this.restrictedToSizes.includes(item.size))
    }
  },
  methods: {
    onSizeClick (opt) {
      this.$refs.dropdown.hide()
      this.$emit('run', 'fontSize', opt.size)
    }
  }
}
</script>
